import React from 'react';
import { Box } from '@mui/material';

// Helper to clone and apply gradient fill to MUI icons
const GradientIcon = ({ icon }) => (
  <svg width={40} height={40} viewBox="0 0 40 40" style={{ display: 'block' }}>
    <defs>
      <linearGradient id="icon-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#6e7eea" />
        <stop offset="100%" stopColor="#764ba2" />
      </linearGradient>
    </defs>
    {/* Render the icon as a child, with gradient fill */}
    {React.cloneElement(icon, {
      htmlColor: 'url(#icon-gradient)',
      style: { width: 32, height: 32 },
    })}
  </svg>
);

const AnimatedIcon = ({ icon, label, highlight }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      p: 1.5,
      background: '#fff',
      boxShadow: highlight ? '0 0 16px 2px #6e7eea55' : '0 2px 8px 0 #eee8',
      transition: 'transform 0.18s cubic-bezier(.4,2,.6,1), box-shadow 0.18s',
      cursor: 'pointer',
      '&:hover': {
        transform: 'scale(1.13)',
        boxShadow: highlight
          ? '0 0 32px 4px #6e7eea99'
          : '0 0 16px 2px #6e7eea55',
        background: '#fff',
      },
    }}
    aria-label={label}
    tabIndex={0}
  >
    <GradientIcon icon={icon} />
  </Box>
);

export default AnimatedIcon; 